import numeral from 'numeral';

export class NumberFormatValueConverter {
    toView(value, format) {
        var formats = format.split(':');
        if (formats.length == 2) {
            if (value == 0) {
                return formats[1];
            } else {
                format = formats[0];
            }
        }

        if (!isNaN(parseFloat(value) && isFinite(value))) {
            return numeral(value).format(format);
        }

        return value;
    }

    fromView(value, format) {
        var formats = format.split(':');
        if (formats.length == 2) {
            if (value == 'Open') {
                return 0;
            } else {
                format = formats[0];
            }
        }

        if (!isNaN(parseFloat(value) && isFinite(value))) {
            return numeral(value).format(format);
        }

        return value;
    }
}
